(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[86646],{

/***/ 15460:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.E = function BiUser (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"circle","attr":{"fill":"none","cx":"12","cy":"7","r":"3"}},{"tag":"path","attr":{"d":"M12 2C9.243 2 7 4.243 7 7s2.243 5 5 5 5-2.243 5-5S14.757 2 12 2zM12 10c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3S13.654 10 12 10zM21 21v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h2v-1c0-2.757 2.243-5 5-5h4c2.757 0 5 2.243 5 5v1H21z"}}]})(props);
};


/***/ }),

/***/ 15787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/refactoringui/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/index.js




/***/ }),

/***/ 86646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Header_MobileTopBar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/bi/BiUser.js
var BiUser = __webpack_require__(15460);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./icons/icons.js
var icons = __webpack_require__(17601);
// EXTERNAL MODULE: ./context/context.js
var context = __webpack_require__(94268);
;// CONCATENATED MODULE: ./helper/fetcher.js
var fetcher = function(url) {
    return fetch(url, {
        headers: {
            Site: "3"
        }
    }).then(function(res) {
        return res.json();
    });
};

// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/Header/MobileTopBar.js











var MobileMenuContent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 99599).then(__webpack_require__.bind(__webpack_require__, 99599));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99599)
            ];
        }
    }
});
var MobileTopBar = function(param) {
    var isAppWebView = param.isAppWebView;
    var OpenMobileMenu = function OpenMobileMenu() {
        setMobileMenuIsOpen(true);
        LoadData();
    };
    var CloseMobileMenu = function CloseMobileMenu() {
        if (MobileMenuIsOpen === true) setMobileMenuIsOpen(false);
    };
    var ref = (0,TranslationContext/* useTranslation */.m)(), reservations = ref.reservations, mobileMenuLabel = ref.mobileMenuLabel, favouritesAria = ref.favouritesAria;
    var ref1 = (0,react.useContext)(context/* StoreContext */.x), favouritesIsOpen = ref1.favouritesIsOpen, setFavouritesIsOpen = ref1.setFavouritesIsOpen;
    var ref2 = (0,react.useState)(null), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)(false), isLoaded = ref3[0], setIsLoaded = ref3[1];
    var ref4 = (0,react.useState)(false), data = ref4[0], setData = ref4[1];
    var ref5 = (0,react.useState)(0), MobileMenuIsOpen = ref5[0], setMobileMenuIsOpen = ref5[1];
    var isOpen = favouritesIsOpen;
    function LoadData() {
        return _LoadData.apply(this, arguments);
    }
    function _LoadData() {
        _LoadData = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (data) {
                            _ctx.next = 3;
                            break;
                        }
                        _ctx.next = 3;
                        return fetcher("https://api.balayivillasikirala.com.tr" + "/MobileMenu").then(function(result) {
                            setIsLoaded(true);
                            setData(result);
                        }, // Note: it's important to handle errors here
                        // instead of a catch() block so that we don't swallow
                        // exceptions from actual bugs in components.
                        function(error) {
                            setIsLoaded(true);
                            setError(error);
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _LoadData.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex gap-x-4 lg:hidden items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": favouritesAria,
                onClick: function() {
                    setFavouritesIsOpen(!isOpen);
                },
                className: "border rounded-full p-1 text-red-500",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                    name: "Heart"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: reservations.url,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    "aria-label": reservations.ariaLabel,
                    className: "mm:inline-block ms:hidden ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BiUser/* BiUser */.E, {
                        size: 32,
                        fontWeight: 200
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": mobileMenuLabel,
                onClick: OpenMobileMenu,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                    name: "Bar"
                })
            }),
            MobileMenuIsOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenuContent, {
                closeMobileMenu: CloseMobileMenu,
                data: data,
                isLoaded: isLoaded,
                error: error,
                isAppWebView: isAppWebView
            }) : ""
        ]
    });
};
/* harmony default export */ var Header_MobileTopBar = (MobileTopBar);


/***/ }),

/***/ 17601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Icon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);


var InfoIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 49562).then(__webpack_require__.bind(__webpack_require__, 49562));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49562)
            ];
        }
    }
});
var InstagramIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 81147).then(__webpack_require__.bind(__webpack_require__, 81147));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81147)
            ];
        }
    }
});
var LogoIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 60563).then(__webpack_require__.bind(__webpack_require__, 60563));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60563)
            ];
        }
    }
});
var FacebookIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 55849).then(__webpack_require__.bind(__webpack_require__, 55849));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55849)
            ];
        }
    }
});
var YoutubeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 86759).then(__webpack_require__.bind(__webpack_require__, 86759));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86759)
            ];
        }
    }
});
var DatepickerArrowsIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 10945).then(__webpack_require__.bind(__webpack_require__, 10945));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10945)
            ];
        }
    }
});
var LocationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 34364).then(__webpack_require__.bind(__webpack_require__, 34364));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34364)
            ];
        }
    }
});
var SearchIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 39750).then(__webpack_require__.bind(__webpack_require__, 39750));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39750)
            ];
        }
    }
});
var ArrowDownIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 5915).then(__webpack_require__.bind(__webpack_require__, 5915));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5915)
            ];
        }
    }
});
var TimesIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 36539).then(__webpack_require__.bind(__webpack_require__, 36539));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36539)
            ];
        }
    }
});
var PaymentOptionIcon1 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 57905).then(__webpack_require__.bind(__webpack_require__, 57905));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57905)
            ];
        }
    }
});
var PaymentOptionIcon2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18686).then(__webpack_require__.bind(__webpack_require__, 18686));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18686)
            ];
        }
    }
});
var HeartIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 14119).then(__webpack_require__.bind(__webpack_require__, 14119));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14119)
            ];
        }
    }
});
var AttentionIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 55613).then(__webpack_require__.bind(__webpack_require__, 55613));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55613)
            ];
        }
    }
});
var FaturaIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 52415).then(__webpack_require__.bind(__webpack_require__, 52415));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52415)
            ];
        }
    }
});
var CallIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 26006).then(__webpack_require__.bind(__webpack_require__, 26006));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26006)
            ];
        }
    }
});
var WhatsappnewIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 40305).then(__webpack_require__.bind(__webpack_require__, 40305));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40305)
            ];
        }
    }
});
var ReverseIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 72142).then(__webpack_require__.bind(__webpack_require__, 72142));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72142)
            ];
        }
    }
});
var MapIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 88450).then(__webpack_require__.bind(__webpack_require__, 88450));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88450)
            ];
        }
    }
});
var Icons_new = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 793).then(__webpack_require__.bind(__webpack_require__, 793));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(793)
            ];
        }
    }
});
var Icons_new2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 14973).then(__webpack_require__.bind(__webpack_require__, 14973));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14973)
            ];
        }
    }
});
var Icons_new3 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 38796).then(__webpack_require__.bind(__webpack_require__, 38796));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38796)
            ];
        }
    }
});
var Icons_new4 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 68344).then(__webpack_require__.bind(__webpack_require__, 68344));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68344)
            ];
        }
    }
});
var WorkingIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 73477).then(__webpack_require__.bind(__webpack_require__, 73477));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73477)
            ];
        }
    }
});
var ProblemreportIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 44059).then(__webpack_require__.bind(__webpack_require__, 44059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44059)
            ];
        }
    }
});
var WheltimeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 63270).then(__webpack_require__.bind(__webpack_require__, 63270));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63270)
            ];
        }
    }
});
var GancelIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 51623).then(__webpack_require__.bind(__webpack_require__, 51623));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51623)
            ];
        }
    }
});
var GuestconfirmationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 21443).then(__webpack_require__.bind(__webpack_require__, 21443));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21443)
            ];
        }
    }
});
var CloseIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 25194).then(__webpack_require__.bind(__webpack_require__, 25194));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25194)
            ];
        }
    }
});
var VillaLocationIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 34920).then(__webpack_require__.bind(__webpack_require__, 34920));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34920)
            ];
        }
    }
});
var PlayButtonIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 17686).then(__webpack_require__.bind(__webpack_require__, 17686));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17686)
            ];
        }
    }
});
var DetailIncludedPriceIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 59715).then(__webpack_require__.bind(__webpack_require__, 59715));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59715)
            ];
        }
    }
});
var BarIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 19272).then(__webpack_require__.bind(__webpack_require__, 19272));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19272)
            ];
        }
    }
});
var CallCenterIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18238).then(__webpack_require__.bind(__webpack_require__, 18238));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18238)
            ];
        }
    }
});
var UserIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 78822).then(__webpack_require__.bind(__webpack_require__, 78822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78822)
            ];
        }
    }
});
var ClockIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 76255).then(__webpack_require__.bind(__webpack_require__, 76255));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76255)
            ];
        }
    }
});
var PaginationPrevIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 17151).then(__webpack_require__.bind(__webpack_require__, 17151));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17151)
            ];
        }
    }
});
var PaginationNextIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18229).then(__webpack_require__.bind(__webpack_require__, 18229));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18229)
            ];
        }
    }
});
var ShareIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 91788).then(__webpack_require__.bind(__webpack_require__, 91788));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91788)
            ];
        }
    }
});
var HousekeepingIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 29097).then(__webpack_require__.bind(__webpack_require__, 29097));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29097)
            ];
        }
    }
});
var CameraIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 22437).then(__webpack_require__.bind(__webpack_require__, 22437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22437)
            ];
        }
    }
});
var TeamIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 42908).then(__webpack_require__.bind(__webpack_require__, 42908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42908)
            ];
        }
    }
});
var CommentIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 97088).then(__webpack_require__.bind(__webpack_require__, 97088));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97088)
            ];
        }
    }
});
var WalletIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18688).then(__webpack_require__.bind(__webpack_require__, 18688));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18688)
            ];
        }
    }
});
var UserodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 18024).then(__webpack_require__.bind(__webpack_require__, 18024));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18024)
            ];
        }
    }
});
var MailodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 37822).then(__webpack_require__.bind(__webpack_require__, 37822));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37822)
            ];
        }
    }
});
var PhoneodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 28892).then(__webpack_require__.bind(__webpack_require__, 28892));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28892)
            ];
        }
    }
});
var EditodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 35623).then(__webpack_require__.bind(__webpack_require__, 35623));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35623)
            ];
        }
    }
});
var LockodemeIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9748).then(__webpack_require__.bind(__webpack_require__, 9748));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9748)
            ];
        }
    }
});
var LocationPinIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 80707).then(__webpack_require__.bind(__webpack_require__, 80707));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80707)
            ];
        }
    }
});
var StarIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 99484).then(__webpack_require__.bind(__webpack_require__, 99484));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99484)
            ];
        }
    }
});
var KtbIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 9842).then(__webpack_require__.bind(__webpack_require__, 9842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9842)
            ];
        }
    }
});
var Icon = function(param) {
    var name = param.name, _size = param.size, size = _size === void 0 ? 24 : _size, className = param.className;
    var icons = {
        info: InfoIcon,
        logo: LogoIcon,
        instagram: InstagramIcon,
        facebook: FacebookIcon,
        youtube: YoutubeIcon,
        datepickerArrows: DatepickerArrowsIcon,
        location: LocationIcon,
        search: SearchIcon,
        ArrowDown: ArrowDownIcon,
        Times: TimesIcon,
        PaymentOption1: PaymentOptionIcon1,
        PaymentOption2: PaymentOptionIcon2,
        Heart: HeartIcon,
        attention: AttentionIcon,
        fatura: FaturaIcon,
        call: CallIcon,
        whatsappnew: WhatsappnewIcon,
        reverse: ReverseIcon,
        map: MapIcon,
        newIcon1: Icons_new,
        newIcon2: Icons_new2,
        newIcon3: Icons_new3,
        newIcon4: Icons_new4,
        working: WorkingIcon,
        villaLocation: VillaLocationIcon,
        PlayButton: PlayButtonIcon,
        DetailIncludedPrice: DetailIncludedPriceIcon,
        Bar: BarIcon,
        CallCenter: CallCenterIcon,
        problemreport: ProblemreportIcon,
        wheltime: WheltimeIcon,
        gancel: GancelIcon,
        guestconfirmation: GuestconfirmationIcon,
        close: CloseIcon,
        user: UserIcon,
        clock: ClockIcon,
        PaginationPrev: PaginationPrevIcon,
        PaginationNext: PaginationNextIcon,
        Share: ShareIcon,
        Wallet: WalletIcon,
        Comment: CommentIcon,
        Camera: CameraIcon,
        Housekeeping: HousekeepingIcon,
        Team: TeamIcon,
        userodeme: UserodemeIcon,
        mailodeme: MailodemeIcon,
        phoneodeme: PhoneodemeIcon,
        editodeme: EditodemeIcon,
        lockodeme: LockodemeIcon,
        LocationPin: LocationPinIcon,
        Star: StarIcon,
        ktb: KtbIcon
    };
    var Component = icons[name];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        size: size,
        className: className
    });
};



/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ })

}]);